module.exports = __webpack_public_path__ + "img/ic_chart.3d45b27e.svg";